module.exports = __webpack_public_path__ + "static/media/iphone_banner.e02a48ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone_banner.png
// module id = 887
// module chunks = 0